/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inventory_Metric_Warehouse_Bags_HintInputs */

const en_inventory_metric_warehouse_bags_hint = /** @type {(inputs: Inventory_Metric_Warehouse_Bags_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bags in warehouse storage`)
};

const es_inventory_metric_warehouse_bags_hint = /** @type {(inputs: Inventory_Metric_Warehouse_Bags_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bolsas en almacenamiento`)
};

/**
* | output |
* | --- |
* | "Bags in warehouse storage" |
*
* @param {Inventory_Metric_Warehouse_Bags_HintInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const inventory_metric_warehouse_bags_hint = /** @type {((inputs?: Inventory_Metric_Warehouse_Bags_HintInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inventory_Metric_Warehouse_Bags_HintInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_inventory_metric_warehouse_bags_hint(inputs)
	return es_inventory_metric_warehouse_bags_hint(inputs)
});